// extracted by mini-css-extract-plugin
export const space = "bp_bh";
export const popover = "bp_cL";
export const divider = "bp_cM";
export const header = "bp_bV";
export const loginBut = "bp_cN";
export const profileButton = "bp_cP";
export const profileTxt = "bp_cQ";
export const profileLink = "bp_cR";
export const meunItem = "bp_cS";
export const licenseTxt = "bp_cT";
export const menuIcon = "bp_cV";
export const list = "bp_cW";